import styled from 'styled-components';

export const LightGreyBox = styled.div`
  background-color: var(--color-surface-muted);
`;

export const LightGreyRoundedBox = styled(LightGreyBox)`
  border-radius: 4px;
`;
